import { createFileRoute } from '@tanstack/react-router'
import { AIAgentsPage } from '@/pages/ai-agents'

export const Route = createFileRoute('/_authenticated/ai/')({
  staticData: { title: 'AI Agents' },
  component: AIAgentsPage,
})
